import React, { createContext, useContext } from 'react';
import { errorMessageDuplicateCommonCore } from './constants';
var PfErrorUtilsContext = /*#__PURE__*/createContext(undefined);
export var PfErrorUtilsProvider = function PfErrorUtilsProvider(_ref) {
  var errorUtils = _ref.errorUtils,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(PfErrorUtilsContext.Provider, {
    value: errorUtils
  }, children);
};
export function usePfErrorUtils() {
  var errorUtils = useContext(PfErrorUtilsContext);
  if (errorUtils === undefined) {
    throw new Error("usePfErrorUtils() must be used within a PfErrorUtilsProvider. ".concat(errorMessageDuplicateCommonCore));
  }
  return errorUtils;
}